import React from 'react';

import config from 'config';
import { useRouter } from 'next/router';

import FirstMemberBillingModal from '../layout/components/FirstMemberBillingModal';
import useHasFeature, { featureNames } from '../shared/utils/useHasFeature';
import { useMembership } from '../techstyle-shared/react-accounts';

const FirstMemberBillingModalWrapper = () => {
  const { isVip, isFirstBilling: isCustomerFirstBilling } = useMembership();

  const { enabled: isFirstMemberBillingModalEnabled } = useHasFeature(
    featureNames.FIRST_MEMBER_BILLING_MODAL
  );

  // Prevent the modal from showing on a specific page routes
  const blacklistedRoutes =
    config.get('public.brand.firstMemberBillingModal.blacklistedRoutes') || [];
  const { asPath } = useRouter();
  const asPathWithoutQuery = asPath.split('?')[0];
  const isBlacklistedRoute = blacklistedRoutes.includes(asPathWithoutQuery);

  if (
    isFirstMemberBillingModalEnabled &&
    isCustomerFirstBilling &&
    isVip &&
    !isBlacklistedRoute
  ) {
    return <FirstMemberBillingModal />;
  }

  return null;
};

export default function firstMemberBillingModalExtension() {
  return {
    id: 'firstMemberBillingModal',
    app: {
      render(props, children) {
        return (
          <>
            {children}
            <FirstMemberBillingModalWrapper {...props} />
          </>
        );
      },
    },
  };
}
